import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ScheduleRequestsService} from "../../services/schedule-requests.service";


export class ScheduleTemplateSelectComponent implements IController {
  selectedId: any;
  optionIds: any;
  ngPlaceholder: any;
  onChange: Function;

  loaded: boolean = false;
  searchTerm: string = '';
  selectedTemplate: any = undefined;
  templatesRef: any;
  templatesList: any;

  constructor(private scheduleRequestsService: ScheduleRequestsService, private $mdSelect, private $log, private $scheduleTemplate) {
    this.templatesRef = this.$scheduleTemplate();
  }

  $onInit() {
    if (this.selectedId) {
      if (this.optionIds) {
        this.getByOptionIds();
      } else {
        this.getAll();
      }
    }
  }

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      if (changes.selectedId.currentValue) {
        const selectedId = changes.selectedId.currentValue;
        const currentTemplateIds = _.map(this.templatesList, 'id')
        if (!_.includes(currentTemplateIds, selectedId)) {
          this.templatesRef.$asyncValues([changes.selectedId.currentValue].concat(currentTemplateIds))
            .then((templates) => {
              this.templatesList = templates;
              this.selectedTemplate = _.find(templates, (t) => {
                return t.id === this.selectedId;
              })
            })
        }
      } else {
        this.selectedTemplate = undefined
      }
    }
  }

  onOpen() {
    if (this.optionIds) {
      return this.getByOptionIds();
    } else {
      return this.getAll()
    }
  }

  cancel() {
    this.$mdSelect.hide();
  }

  doneHideSelect() {
    this.searchTerm = '';
    this.$mdSelect.hide();
  }

  private getAll() {
    return this.scheduleRequestsService.getAllTemplates()
      .then((templates) => {
        this.templatesList = templates;
        this.selectedTemplate = _.find(templates, (t) => {
          return t.id === this.selectedId;
        })
        this.loaded = true;
      })
      .catch((error) => {
        this.$log.error('Failed to get service areas @scheduleTemplateSelect@onOpen', error);
      });
  }

  private getByOptionIds() {
    return this.templatesRef.$asyncValues(this.optionIds);
  }

}

angular
  .module('bringoz.admin.schedule')
  .component('scheduleTemplateSelect', {
    bindings: {
      selectedId: '<',
      optionIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    templateUrl: 'app/modules/schedule/components/schedule-template-select/schedule-template-select.html',
    controller: ScheduleTemplateSelectComponent
  });
